import { paginaArticulos } from './partes.js'; 
import { mostrarToast, obtenerUrlBackend } from './utilerias.js';
import { GestorGrafica } from './graficaModulo.js';

let graficaArticulos;


export function paginaarticuloCtesTab(articuloId) {



    const URL_BASE_API = obtenerUrlBackend('8083');

    const URL_BASE = `${URL_BASE_API}/api/articuloClientes`;
    const URL_API = `${URL_BASE}/${articuloId}`;

    const URL_METRICAS_MENSUALES = `${URL_BASE_API}/api/datosarticulo/${articuloId}`; 
    const URL_DATOS_ICE = `${URL_BASE_API}/api/datosIce/${articuloId}`;




    const html = `
        <div class="container-fluid">
        <header>
           
        </header>
        
        <div id="estado-contenedor" class="alert alert-info" role="alert">
            <p id="mensaje-estado" class="mb-0">Cargando datos del servidor...</p>
        </div>

       <section id="seccion-encabezado" class="mb-4 d-none">            
            <div id="contenedor-encabezado" class="row g-0 m-0">
                    
                    <div class="col-12 mb-3">
                        <div class="card shadow-sm h-100">
                           <div class="card-header-custom p-3 text-white d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-4"> 
                                
                                <div>

                                    <a href="javascript:void(0)" id="btn-regresar-tableros" class="text-white me-3" title="Regresar a Tableros">
                                        
                                        <i class="fa-solid fa-lg fa-arrow-left icon-back"></i>
                                        
                                    </a>
                                    <span id="hdr-articulo" class="fw-bold style-code">N/A</span>

                                    <a href="javascript:void(0)" 
                                        class="text-primary art-link-grafica"
                                        data-bs-toggle="modal" 
                                        data-bs-target="#art-modalGraficaSelector" 
                                        title="Ver métricas mensuales">
                                        <i class="fa-solid fas fa-chart-line ms-3" style="cursor: pointer; font-size: 1.8rem; color:white"></i>
                                    </a>
                                    <span class="mx-4"></span>
                                    <span id="hdr-desc-articulo" class="style-name">N/A</span>
                                </div>

                                <div class="status-badge">
                                    Estatus: 
                                    <strong id="hdr-status">N/A</strong>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div class="col-12 mb-3">
                        <div class="card shadow-sm h-100">                     
                            <div class="card-body metrics-container border-bottom"> 
                                <div class="metric-box">
                                    <p class="metric-label">Posición (Parte):</p>
                                    <strong id="hdr-posicion-parte" class="metric-value">N/A</strong>
                                </div>
                                <div class="metric-box">
                                    <p class="metric-label">Total Clientes:</p>
                                    <strong id="hdr-total-clientes" class="metric-value">N/A</strong>
                                </div>     
                                <div class="metric-box">
                                    <p class="metric-label">% Vta:</p>
                                    <strong id="hdr-porc-vta" class="metric-value">N/A</strong>
                                </div>  

                                <div class="metric-box">
                                    <p class="metric-label">% Vta Acum:</p>
                                    <strong id="hdr-porc-vta-acum" class="metric-value">N/A</strong>
                                </div>  

                                <div class="metric-box">
                                    <p class="metric-label">CVPM (Metros):</p>
                                    <strong id="hdr-cvpm-metros" class="metric-value">N/A</strong>
                                </div>  
                                <div class="metric-box">
                                    <p class="metric-label">Importe Total:</p>
                                    <strong id="hdr-importe-total" class="metric-value">N/A</strong>
                                </div>  
                                <div class="metric-box">
                                    <p class="metric-label">Precio Promedio:</p>
                                    <strong id="hdr-precio-prom" class="metric-value">N/A</strong>
                                </div>  
                                <div class="metric-box">
                                    <p class="metric-label">Colores:</p>
                                    <a href="#" id="link-colores" data-bs-toggle="modal" data-bs-target="#modalColores">
                                        <strong id="hdr-tot-colores" class="metric-value">N/A</strong>
                                    </a>
                                </div>

                             
                                <div class="card-body">
                                        <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#modalDetalleICE">
                                            ICE
                                        </button>
                                </div>
                            </div>
                            <div class="card-body py-3">
                                <div class="row g-3">
                                    <div class="cards-inferiores-container">
                                        <!-- Card Azul: Total Parte -->
                                        <div class="card shadow-sm card-inferior">
                                            <div class="card-header card-header-azul">
                                                Total Parte
                                            </div>
                                            <div class="card-body">
                                                
                                                <div class="card-metrica-item">
                                                    <p class="card-metrica-label">CVPM Metros:</p>
                                                    <strong id="hdr-cte-partcvpm" class="card-metrica-value">N/A</strong>
                                                </div>

                                                <div class="card-metrica-item">
                                                    <p class="card-metrica-label">CVPM Importe:</p>
                                                    <strong id="hdr-cte-partimporte" class="card-metrica-value">N/A</strong>
                                                </div>

                                                <div class="card-metrica-item">
                                                    <p class="card-metrica-label">Porcentaje:</p>
                                                    <strong id="hdr-cte-partporc" class="card-metrica-value">N/A</strong>
                                                </div>
                                                
                                            </div>
                                        </div>
                        

                                        <div class="card shadow-sm card-inferior">
                                            <div class="card-header card-header-verde">
                                                Total Clientes Estilo: 
                                                    <a href="javascript:void(0)" 
                                                        id="link-estilo-id" 
                                                        class="text-decoration-none ms-1 fw-bold" 
                                                        style="color: #1E3A5F;"
                                                        data-bs-toggle="modal" 
                                                        data-bs-target="#modalKPIsEst">
                                                        <span id="hdr-clave-estilo">N/A</span>
                                                    </a>
                                            </div> 
                                            <div class="card-body">
                                            
                                                <div class="card-metrica-item">
                                                    <p class="card-metrica-label">CVPM Metros:</p>
                                                    <strong id="hdr-cte-est-cvpm" class="card-metrica-value">N/A</strong>
                                                </div>
                                                <div class="card-metrica-item">
                                                    <p class="card-metrica-label">Importe:</p>
                                                    <strong id="hdr-cte-est-monto" class="card-metrica-value">N/A</strong>
                                                </div>
                                                
                                                <div class="card-metrica-item">
                                                    <p class="card-metrica-label">%:</p>
                                                    <strong id="hdr-porc-estilo" class="card-metrica-value">N/A</strong>
                                                </div>                                              
                                            </div>
                                        </div>
                                        
                                        <div class="card shadow-sm card-inferior">
                                            <div class="card-header card-header-amarillo">
                                                    Total Clientes 
                                            </div>
                                            <div class="card-body">
                                                <div class="card-metrica-item">
                                                    <p class="card-metrica-label">Importe:</p>
                                                    <strong id="hdr-cte-importe" class="card-metrica-value">N/A</strong>
                                                </div>   
                                                <div class="card-metrica-item">
                                                    <p class="card-metrica-label">Porcentaje:</p>
                                                    <strong id="hdr-porc-cte" class="card-metrica-value">N/A</strong>
                                                </div>   
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </section>

        <section id="seccion-detalle" class="mb-4 d-none">          
            <div class="table-responsive">            
               <table id="tabla-detalles" class="table table-striped table-hover border">
                    <thead class="table-secondary">
                        <tr>
                            <th>Clave<br>Cliente</th>
                            <th>Nombre</th>
                            <th>CVPM Parte</th>
                            <th>Importe Parte</th>
                            <th>% Parte</th>
                            <th>CVPM Estilo</th>
                            <th>Importe Estilo</th>
                            <th>% Estilo</th>
                            <th>Pos.<br>Cliente</th>
                            <th>Importe Cliente</th>
                            <th>% Cliente</th>
                        </tr>
                    </thead>
                    <tbody>
                    </tbody>
                </table>
            </div>
        </section>
        
    </div>

    <div class="modal fade modal-corporativo" id="modalColores" data-bs-backdrop="false" tabindex="-1" aria-labelledby="modalColoresLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg"> 
            <div class="modal-content">
                <div class="modal-header"> 
                    <h5 class="modal-title" id="modalColoresLabel">Colores del Artículo</h5>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>   
                            
                </div>
                <div class="modal-body">
                    <table id="tabla-colores" class="table table-striped table-hover border w-100">
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal modal-corporativo" id="art-modalGraficaSelector" data-bs-backdrop="false" tabindex="-1" aria-labelledby="art-modalGraficaSelectorLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="d-flex align-items-center">
                        <h5 class="modal-title" id="art-modalGraficaSelectorLabel">Selección de Métricas Mensuales</h5>
                        <button type="button" class="btn btn-sm btn-outline-light ms-3" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#art-cont-seleccion-metricas" 
                            aria-expanded="false" 
                            aria-controls="art-cont-seleccion-metricas">
                            <i class="fa-solid fa-sliders me-1"></i> Parámetros
                        </button>
                    </div>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div id="art-cont-seleccion-metricas" class="collapse border-bottom pb-3 mb-3">
                        <div class="card card-body bg-light">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <h6><i class="fa-solid fa-calendar-range"></i> Rango de Periodo:</h6>
                                    <div class="row mb-3">
                                        <div class="col-12 col-sm-6 mb-2">
                                            <label for="art-fecha-inicio" class="form-label small">Desde:</label>
                                            <input type="month" id="art-fecha-inicio" class="form-control">
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <label for="art-fecha-fin" class="form-label small">Hasta:</label>
                                            <input type="month" id="art-fecha-fin" class="form-control">
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-2 fw-bold text-center" style="font-size: 0.8rem; color: #666;">
                                    <div class="col-6 text-start">Concepto</div>
                                    <div class="col-3">Promedio</div>
                                    <div class="col-3">Real</div>
                                     <div class="col-12" style="height: 25px; border-bottom: 2px solid #dee2e6;"></div>
                                </div>
                                <div id="lista-metricas-checkboxes"></div>
                            </div>

                            <div class="text-end mt-3">
                                <button type="button" class="btn btn-success btn-sm" id="btn-gen-grafarts">
                                    <i class="fa-solid"></i> Generar Gráfica
                                </button>
                            </div>
                        </div>
                    </div>

                    <div style="height: 400px; width: 100%;">
                        <canvas id="grafica-seleccionada"></canvas>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div> 
    </div>


    <div class="modal fade" id="modalKPIsEst" data-bs-backdrop="false" tabindex="-1" aria-labelledby="modalKPIsEstLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0" 
                        style="background-color: #EBF2E6; ">
                        <h5 class="modal-title fw-bold" id="modalKPIsEstLabel" style="color: #1E3A5F;">
                            
                            Resumen de Indicadores Estilo: <span id="modal-hdr-estilo-nombre">--</span>
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    
                    <div class="modal-body bg-light">
                        <div class="row g-3">
                            <div class="col-6">
                                <div class="p-3 bg-white border rounded shadow-sm text-center">
                                    <p class="text-muted mb-1 small fw-bold">% Venta</p>
                                    <h4 id="modal-kpi-porc-vta" class="mb-0 fw-bold">6.29%</h4>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="p-3 bg-white border rounded shadow-sm text-center">
                                    <p class="text-muted mb-1 small fw-bold">CVPM Metros</p>
                                    <h4 id="modal-kpi-cvpm" class="mb-0 fw-bold">672,476</h4>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="p-3 bg-white border rounded shadow-sm text-center">
                                    <p class="text-muted mb-1 small fw-bold">Posición</p>
                                    <h4 id="modal-kpi-posicion" class="mb-0 fw-bold">1</h4>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="p-3 bg-white border rounded shadow-sm text-center">
                                    <p class="text-muted mb-1 small fw-bold">Precio Prom Metro</p>
                                    <h4 id="modal-kpi-precio-prom" class="mb-0 fw-bold">$0.37</h4>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="p-3 bg-white border rounded shadow-sm text-center">
                                    <p class="text-muted mb-1 small fw-bold">Importe Prom</p>
                                    <h4 id="modal-kpi-importe-prom" class="mb-0 fw-bold">$246,518</h4>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="p-3 bg-white border rounded shadow-sm text-center">
                                    <p class="text-muted mb-1 small fw-bold">Colores con venta</p>
                                    <h4 id="modal-kpi-colores" class="mb-0 fw-bold">5</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-top-0 bg-light">
                        <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Detalle del ICE -->
        <div class="modal fade modal-ice" id="modalDetalleICE" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
            
                    <!-- Header -->
                    <div class="modal-header bg-secondary text-white">
                        <h5 class="modal-title fw-bold">Detalle ICE</h5>
                        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                
                    <!-- Body -->
                    <div class="modal-body p-0">
                        <div class="table-responsive">
                            <!-- Tabla vacía para DataTables -->
                            <table id="tabla-ice" class="table table-borderless mb-0">
                                <thead class="table-primary">
                                    <tr>
                                        <th class="ps-3 py-2">Concepto</th>
                                        <th class="text-end py-2">Almacén A</th>
                                        <th class="text-end py-2">Almacén B</th>
                                        <th class="text-end pe-3 py-2">Almacén C</th>
                                        <th class="text-end pe-3 py-2">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- DataTables llena esto automáticamente -->
                                </tbody>
                            </table>
                        </div>
                    </div>
            
                    <!-- Footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                
                </div>
            </div>
        </div>
    `;
    
    setTimeout(async () => {

        graficaArticulos = new GestorGrafica({
            idInicio: 'art-fecha-inicio',
            idFin: 'art-fecha-fin',
            idContenedorMetricas: 'lista-metricas-checkboxes',
            idCanvas: 'grafica-seleccionada',
            storageKey: 'preferenciasGraficaArticulo',
            selectorCheckboxes: '.art-metrica-selector'
        });
        await obtenerYRenderizarDatosArticulo(URL_API, articuloId);    
        obtenerDatosICE(URL_DATOS_ICE, articuloId); 
        
        const datosMensuales = await obtenerDatosMensualesParaGrafica(URL_METRICAS_MENSUALES, articuloId);
        
        if (datosMensuales) {
            graficaArticulos.configurarModalGrafica(datosMensuales);
        }

        const btnGenerarGrafica = document.getElementById('btn-gen-grafarts');
        if (btnGenerarGrafica) {
            btnGenerarGrafica.addEventListener('click', () => {
                graficaArticulos.generarGraficaArts();
            });
        }
        
        const btnRegresar = document.getElementById('btn-regresar-tableros');
        if (btnRegresar) {
            btnRegresar.addEventListener('click', (e) => {
                e.preventDefault();
                const lienzo = document.querySelector('.content');
                if (lienzo) {
                    lienzo.innerHTML = paginaArticulos(); 
                }
            });
        }

    }, 100);

    return html;
}

// ID de la tabla de DETALLES
const ID_TABLA = '#tabla-detalles'; 



let datosMensualesGlobal = [];
let datosColoresGlobal = []; 
let datosICE = []; 

async function obtenerYRenderizarDatosArticulo(url, articuloId) {
    const mensajeEstado = document.getElementById('mensaje-estado');
    if (!url) {
        mensajeEstado.textContent = "❌ ERROR: No se recibió la URL.";
        return;
    }
    
    mensajeEstado.textContent = `Cargando detalles del Artículo ${articuloId}...`;

    try {

        const token = sessionStorage.getItem('token_teresita');

        const respuesta = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        });

        if (!respuesta.ok) {
            if (respuesta.status === 401 || respuesta.status === 403) {
                throw new Error("Sesión inválida o expirada. Por favor, inicia sesión de nuevo.");
            }
            else {
            const errorData = await respuesta.json();
            throw new Error(errorData.error);
            }
        }

        const cajaGrande = await respuesta.json();
        
        const encabezado = cajaGrande.encabezado;
        const detalles = cajaGrande.detalles || [];
        const colores = cajaGrande.colores || []; 

        datosColoresGlobal = colores; 

        if (detalles.length === 0) {
             
             mostrarToast(`⚠️ No hay detalles para el Artículo ${articuloId}.`); 
             return;
        }

        renderizarEncabezado(encabezado, colores);
        inicializarDataTable(detalles);

        
        mensajeEstado.textContent = `✅ Artículo ${articuloId}: ${detalles.length} registros.`;
        configurarModalColores();
        configurarModalKpisEst();

    } catch (error) {
        console.error("Fallo:", error);
        mostrarToast(error.message, 'warning'); 
    }
}

async function obtenerDatosMensualesParaGrafica(url, articuloId) {
    const mensajeEstado = document.getElementById('mensaje-estado');
    try {

        debugger
        const token = sessionStorage.getItem('token_teresita');
        const respuesta = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        });

        if (!respuesta.ok) {
            if (respuesta.status === 401 || respuesta.status === 403) {
                throw new Error("Sesión inválida o expirada. Por favor, inicia sesión de nuevo.");
            }
            throw new Error(`Error en el servidor: ${respuesta.status}`);
        }

        const resultado = await respuesta.json();
        const datosParaUsar = resultado || [];

        if (datosParaUsar.length === 0) {
             
             mostrarToast('No hay datos para graficar.', 'warning');
             return;
        }
        datosMensualesGlobal = datosParaUsar;
        return datosMensualesGlobal;
        
       

    } catch (error) {
        console.error("Fallo al obtener métricas mensuales:", error);
        return null;
    }
}

async function obtenerDatosICE(url, articuloId) {
    try {
        const token = sessionStorage.getItem('token_teresita');
        const respuesta = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        });

        if (!respuesta.ok) {
            throw new Error(`Error ${respuesta.status}`);
        }

        const datos = await respuesta.json();
        
        if (!datos || datos.length === 0) {
            //console.log('No hay datos ICE');
            mostrarToast('No hay datos ICE.', 'warning');
            return;
        }
        
        datosICE = datos;
        // Datos ya vienen normalizados, usar directamente
        inicializarDataICE(datosICE);

    } catch (error) {
        console.error("Error al obtener ICE:", error);
        mostrarToast(error.message, 'warning');
    }
}

function renderizarEncabezado(data, colores) {

    const getFormattedNumber = (value, decimals = 2, prefix = '', isPercentage = false) => {
            if (value === null || value === undefined) {
                return 'N/A';
            }
            
            const num = parseFloat(value); 
            if (isNaN(num)) {
                return 'N/A';
            }
            
            let finalNum = num;
            
            if (isPercentage) {
                let precision = (decimals > 0) ? decimals : 0;
                if (decimals === 2 && num === Math.round(num)) {
                    precision = 0;
                }
                return finalNum.toFixed(precision) + '%'; 
            }
            
            let formatOptions = {};
            
            if (decimals > 0) {
                formatOptions = { 
                    minimumFractionDigits: decimals, 
                    maximumFractionDigits: decimals 
                };
            } else {
                formatOptions = { 
                    maximumFractionDigits: 0 
                };
            }
            
            const formattedNum = finalNum.toLocaleString('es-MX', formatOptions);
            
            return prefix + formattedNum;
        };
    
    const totalColores = colores.length;
    
    // Mapeo de campos del API de Artículos a IDs de elementos HTML
    const mapeoEncabezado = {
        'hdr-articulo': data.parte_clave,
        'hdr-desc-articulo': data.vp_part_desc_part,
        'hdr-posicion-parte': data.posicion_parte,
        'hdr-total-clientes': data.total_clientes_por_parte,
        'hdr-clave-estilo': data.parte_estilo,
        
        'hdr-importe-total': getFormattedNumber(data.vp_part_monto_metros, 2, '$'),
        'hdr-cvpm-metros': getFormattedNumber(data.vp_part_cvpm_metro, 0), 
        'hdr-precio-prom': getFormattedNumber(data.vp_part_precio_metro, 2, '$'), 
        'hdr-status': data.vp_part_status,
        
        'hdr-porc-vta': getFormattedNumber(data.vp_part_porc),
        'hdr-porc-vta-acum': getFormattedNumber(data.vp_part_porc_acum, 2),
        
        // Franja Verde (Datos totales del Estilo en el contexto del cliente)
        'hdr-cte-est-cvpm': getFormattedNumber(data.ce_total_cvpm_metro, 0),
        'hdr-cte-est-monto': getFormattedNumber(data.ce_total_monto_metros, 2, '$'),
        'hdr-porc-estilo': getFormattedNumber(data.ce_porcentaje, 2, '', true),
        
        // Franja Amarilla (Datos totales del Clientes)
        'hdr-cte-importe': getFormattedNumber(data.cte_cte_importe, 2, '$'),
        'hdr-porc-cte': getFormattedNumber(data.cte_cte_porcentaje, 2, '', true),

        // Franja Azul (Datos totales del articulo)
        'hdr-cte-partcvpm': getFormattedNumber(data.cp_total_cvpm_metro, 0),
        'hdr-cte-partimporte': getFormattedNumber(data.cp_total_monto_metro, 2, '$'),
        'hdr-cte-partporc': getFormattedNumber(data.cp_total_porcentaje_parte, 2, '', true),

        'modal-hdr-estilo-nombre':data.parte_estilo,
        
        'hdr-tot-colores': totalColores > 0 ? `${totalColores} ` : 'N/A',


        'modal-kpi-porc-vta': getFormattedNumber(data.vp_est_porc, 2, '', true),
        'modal-kpi-cvpm': getFormattedNumber(data.vp_est_cvpm_metro, 0),
        'modal-kpi-posicion': data.posicion_estilo,
        'modal-kpi-precio-prom': getFormattedNumber(data.vp_est_precio_metro, 2, '$'),
        'modal-kpi-importe-prom': getFormattedNumber(data.vp_est_monto_metros, 2, '$'),
        'modal-kpi-colores': colores.length


    };

    Object.keys(mapeoEncabezado).forEach(id => {
        const elemento = document.getElementById(id);
        if (elemento) {
            elemento.textContent = mapeoEncabezado[id];
        }
    });

    const linkColores = document.getElementById('link-colores');
    if (linkColores) {
        linkColores.style.pointerEvents = totalColores > 0 ? 'auto' : 'none';
        linkColores.style.color = totalColores > 0 ? 'inherit' : '#888';
    }

    document.getElementById('seccion-encabezado').classList.remove('d-none');
    document.getElementById('seccion-detalle').classList.remove('d-none');
}

$.fn.dataTable.ext.search.push(
    function(settings, data, dataIndex) {
        const numericTitles = [
            'CVPM Parte', 
            'Importe Parte', 
            '% Parte',
            'CVPM Estilo',
            'Importe Estilo',
            '% Estilo',
            'Importe Cliente', 
            '% Cliente'
        ];
        
        const api = new $.fn.dataTable.Api(settings);
        const headers = api.columns().header().toArray();
        
        for (let i = 0; i < headers.length; i++) {
            const title = $(headers[i]).text().trim();
            
            if (!numericTitles.includes(title)) {
                continue;
            }

            const cellData = data[i];
            const filtroInput = $(headers[i]).find('input').val() || '';
            
            const match = filtroInput.match(/^([<>=]+)\s*([\d.,]+)$/);
            
            if (!match) {
                continue;
            }

            const operator = match[1];
            let numFilter = match[2];
            
            const numData = parseFloat(cellData.replace(/[^0-9.-]+/g, ''));
            numFilter = parseFloat(numFilter.replace(/[^0-9.-]+/g, ''));

            if (isNaN(numData) || isNaN(numFilter)) {
                return false; 
            }

            let result = false;
            switch (operator) {
                case '>': result = numData > numFilter; break;
                case '<': result = numData < numFilter; break;
                case '>=': result = numData >= numFilter; break;
                case '<=': result = numData <= numFilter; break;
                case '=': result = numData === numFilter; break;
            }
            
            if (!result) {
                return false;
            }
        }
        
        return true;
    }
);



function inicializarTablaColores(datos) {
    
    if ($.fn.DataTable.isDataTable('#tabla-colores')) {
        $('#tabla-colores').DataTable().destroy();
    }
    
    const columnasDefColores = [
        { data: 'vp_est_col_color', title: 'Color' },
        { data: 'vp_est_col_desc_color', title: 'Descripción' },
        { 
            data: 'vp_est_col_cvpm_metro', 
            title: 'CVPM Metro',
            render: $.fn.dataTable.render.number( ',', '.', 0, '' ) 
        },
        { 
            data: 'vp_est_col_monto_metros', 
            title: 'Monto Metros',
            render: $.fn.dataTable.render.number( ',', '.', 2, '$' ) 
        },
        { 
            data: 'porcentaje_color', 
            title: '% Total',
            render: function(data) {
                const num = parseFloat(data);
                if (isNaN(num)) return 'N/A';
                return num.toFixed(0) + '%'; 
            }
        }
    ];

    $('#tabla-colores').DataTable({
        data: datos,
        columns: columnasDefColores,
        destroy: true,
        paging: true,
        searching: true,
        lengthChange: false,
        pageLength: 10,
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
        },
        dom: 'rtip',
        
        initComplete: function() {
            
        }
    });
    
}

export function configurarModalColores() {

    const modal = document.getElementById('modalColores');
    
    if (modal) {

        modal.addEventListener('show.bs.modal', function (event) {
            inicializarTablaColores(datosColoresGlobal);
            modal.focus(); 
        });

        modal.addEventListener('hidden.bs.modal', function (event) {
            if ($.fn.DataTable.isDataTable('#tabla-colores')) {
                $('#tabla-colores').DataTable().destroy();
                $('#tabla-colores').empty(); 
            }
        });
    }       
}


export function configurarModalKpisEst() {
    const modal = document.getElementById('modalKPIsEst');
    
    if (modal) {
        
        modal.addEventListener('show.bs.modal', function (event) {
            
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(bd => bd.remove());
            document.body.classList.remove('modal-open');
        });
        
        
        modal.addEventListener('hidden.bs.modal', function (event) {
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(bd => bd.remove());
            document.body.classList.remove('modal-open');
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '';
        });
    }      
}



function inicializarDataTable(datos) {
    const storageKey = `DataTables_filtros_articulo`;
    const columnasDef = [
        
        { data: 'cliente_clave', title: 'Clave Cliente' },
        { data: 'vp_cte_name', title: 'Nombre' },
        { 
            data: 'vp_cte_part_cvpm_metro', 
            title: 'CVPM Parte',
            render: $.fn.dataTable.render.number( ',', '.', 0, '' ) 
        },
        { 
            data: 'vp_cte_part_monto_metro', 
            title: 'Importe Parte',
            render: $.fn.dataTable.render.number( ',', '.', 2, '$' ) 
        },
        { 
            data: 'porcentaje_parte', 
            title: '% Parte',
            render: function(data) { 
                const num = parseFloat(data);
                if (isNaN(num) || data === null) {
                    return '0%'; 
                }           
                return num.toFixed(0) + '%'; 
            }
        },
        { 
            data: 'cte_est_cvpm_metro', 
            title: 'CVPM Estilo',
            render: $.fn.dataTable.render.number( ',', '.', 0, '' ) 
        },
        { 
            data: 'vp_cte_est_monto_metros', 
            title: 'Importe Estilo',
            render: $.fn.dataTable.render.number( ',', '.', 2, '$' ) 
        },
        { 
            data: 'porcentaje_cte_estilo', 
            title: '% Estilo',
            render: function(data) { 
                const num = parseFloat(data);
                if (isNaN(num) || data === null) {
                    return '0%'; 
                }           
                return num.toFixed(0) + '%'; 
            }
        },
        { data: 'posicion_cliente', title: 'Pos. Cliente', className: 'text-center' },
        { 
            data: 'cte_importe', 
            title: 'Importe Cliente',
            render: $.fn.dataTable.render.number( ',', '.', 2, '$' ) 
        },
        { 
            data: 'porcentaje_cte', 
            title: '% Cliente',
            render: function(data) { 
                const num = parseFloat(data);
                if (isNaN(num) || data === null) {
                    return '0%'; 
                }           
                return num.toFixed(0) + '%'; 
            }
        }
        
    ];

    var table = $(ID_TABLA).DataTable({
        data: datos,
        columns: columnasDef,
        retrieve: true,
        destroy: true,
        stateSave: true,
        stateDuration: -1,
        autoWidth: true,
        responsive: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
        },
        
        lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Todos"]],
        pageLength: 50,
        
        dom: '<"row mb-3 align-items-center" <"col-sm-6"B> <"col-sm-6 text-end"l> >rt<"row" <"col-sm-6"i> <"col-sm-6"p> >',
        buttons: [
        { extend: 'colvis', 
          text: '<i class="fas fa-binoculars fa-lg"></i> Columnas', 
          className: 'btn btn-sm',
          postfixButtons: [{
                    text: '<i class="fas fa-eye"></i> Mostrar Todas',
                    action: function (e, dt) { dt.columns().visible(true); }
                }]
        },            
        {
                extend: 'collection',
                text: '<i class="fas fa-download"></i> Exportar', 
                className: 'btn btn-sm', 
                buttons: [
                    { extend: 'copy', text: '<i class="fas fa-copy"></i> Copiar', exportOptions: {columns: ':visible'} },
                    { extend: 'csv', text: '<i class="fas fa-file-csv"></i> CSV', exportOptions: {columns: ':visible'} },
                    { extend: 'excel', text: '<i class="fas fa-file-excel"></i> Excel', exportOptions: {columns: ':visible'} },
                    { extend: 'pdf', text: '<i class="fas fa-file-pdf"></i> PDF', orientation: 'landscape', exportOptions: {columns: ':visible'} },
                    { extend: 'print', text: '<i class="fas fa-print"></i> Imprimir', exportOptions: {columns: ':visible'} }
                ]
        },
        {
                text: '<i class="fas fa-filter"></i> Limpiar Filtros', 
                className: 'btn btn-sm',
                action: function (e, dt) {
                    dt.columns().every(function () {
                        this.search(''); 
                        $(this.header()).find('.filtro-columna').val(''); 
                    });
                    localStorage.removeItem(storageKey);
                    dt.draw();
                }
            }
        
    ],
       initComplete: function () {
            const api = this.api();
            const state = api.state.loaded();
            const numericTitles = [
                'CVPM Parte', 
                'Importe Parte', 
                '% Parte',
                'CVPM Estilo',
                'Importe Estilo',
                '% Estilo',
                'Importe Cliente', 
                '% Cliente'
            ];

            const filtrosOperadores = JSON.parse(localStorage.getItem(storageKey) || '{}');
            const pintarHeaders = () => {
                api.columns().every(function(index) {
                    const header = $(this.header());
                    header.removeClass('card-header-azul card-header-verde card-header-amarillo');
                    if ([0, 1, 2, 3, 4].includes(index)) {
                        header.addClass('card-header-azul');
                    } else if ([5, 6, 7].includes(index)) {
                        header.addClass('card-header-verde');
                    } else if ([8, 9, 10].includes(index)) {
                        header.addClass('card-header-amarillo');  
                    }
                });
            };
            pintarHeaders();
            api.on('column-visibility.dt', () => setTimeout(pintarHeaders, 0));

            api.columns().every(function (colIdx) {
                var column = this;
                var title = $(column.header()).text().trim();
                
                let placeholderText = 'Filtrar ' + title;
                const isNumeric = numericTitles.includes(title);
                
                if (isNumeric) {
                    placeholderText += ' (Ej: >100)';
                }
                
                var input = $('<input type="text" class="filtro-columna form-control form-control-sm" placeholder="' + placeholderText + '" />')
                    .appendTo($(column.header()));

                // ===== RESTAURA FILTROS =====
                
                if (state && state.columns[colIdx] && state.columns[colIdx].search.search) {
                    const valorGuardado = state.columns[colIdx].search.search;
                    const hasOperator = valorGuardado.match(/^[<>=]+/);
                    
                    if (isNumeric && hasOperator) {
                        filtrosOperadores[colIdx] = valorGuardado;
                        localStorage.setItem(storageKey, JSON.stringify(filtrosOperadores));
                        
                        input.val(valorGuardado);
                    } else {
                        input.val(valorGuardado);
                    }
                }
                
                if (filtrosOperadores[colIdx] && (!state || !state.columns[colIdx] || !state.columns[colIdx].search.search)) {
                    const valorOperador = filtrosOperadores[colIdx];
                    input.val(valorOperador);
                    setTimeout(() => {
                        column.draw();
                    }, 100);
                }

                input.on('keyup change clear', function () {
                    const value = this.value;
                    const hasOperator = value.match(/^[<>=]+/);
                    const operadoresActuales = JSON.parse(localStorage.getItem(storageKey) || '{}');
                    
                    if (isNumeric && hasOperator) {
                        if (value === '') {
                            delete operadoresActuales[colIdx];
                        } else {
                            operadoresActuales[colIdx] = value;
                        }
                        localStorage.setItem(storageKey, JSON.stringify(operadoresActuales));
                        column.search('').draw();           
                    } else {
                        if (operadoresActuales[colIdx]) {
                            delete operadoresActuales[colIdx];
                            localStorage.setItem(storageKey, JSON.stringify(operadoresActuales));
                        }    
                        if (column.search() !== value) {
                            column.search(value).draw();
                        }
                    }
                });
            });
    
            api.draw();
            document.getElementById('estado-contenedor').style.display = 'none';
        },
    });
}


function inicializarDataICE(datos) {
    const ID_TABLA_ICE = '#tabla-ice';
    
    
    if ($.fn.DataTable.isDataTable(ID_TABLA_ICE)) {
        $(ID_TABLA_ICE).DataTable().destroy();
    }

    $(ID_TABLA_ICE).find('tbody').empty();

    
    const columnasDef = [
        { 
            data: 'concepto', 
            title: 'Concepto', 
            className: 'ps-3'
        },
        { 
            data: 'a', 
            title: 'Almacén A', 
            className: 'text-end',
            render: data => formatearValorICE(data)
        },
        { 
            data: 'b', 
            title: 'Almacén B', 
            className: 'text-end',
            render: data => formatearValorICE(data)
        },
        { 
            data: 'c', 
            title: 'Almacén C', 
            className: 'text-end pe-3',
            render: data => formatearValorICE(data)
        },
        { 
            data: 'total', 
            title: 'Total', 
            className: 'text-end pe-3',
            render: data => formatearValorICE(data)
        }
    ];

    // Inicializar DataTable
    $(ID_TABLA_ICE).DataTable({
        data: datos,
        columns: columnasDef,
        paging: false,
        searching: false,
        ordering: false,
        info: false,
        autoWidth: false,
        responsive: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
        },
        dom: 't',
        
        // Estilos de filas según contenido
        createdRow: function(row, data, dataIndex) {
            const concepto = (data.concepto || '').toLowerCase();
            
            if (concepto.includes('inventario total') || 
                concepto.includes('otras entradas') || 
                concepto.includes('otras salidas') ||
                concepto.includes('saldo ice')) {
                $(row).addClass('table-primary fw-bold text-dark');
            }
            else if (concepto.includes('subtotal') || concepto === '') {
                $(row).addClass('fw-bold border-top');
            }
            else if (concepto.startsWith('-') || concepto.startsWith('+')) {
                $(row).addClass('text-muted');
            }
        }
    });
}

// Función simple para formatear valores
function formatearValorICE(valor) {
    if (valor === null || valor === undefined || valor === '' || valor === '-') {
        return '-';
    }
    
    const num = parseFloat(valor);
    if (isNaN(num)) {
        return valor;
    }
    
    return num.toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}











